<template>
    <div class="page-container">
        <van-nav-bar title="退货申请" fixed left-arrow @click-left="goableBack()"></van-nav-bar>
        <div class="p-20 bg-color-white product">
            <div class="flex-row flex-a-c">
                <div class="left mr-20">
                    <img :src="order.coverImg">
                </div>
                <div class="right">
                    <div class="fs-16">{{order.title}}</div>
                    <div class="fs-12 mt-5 color-gray-dark">{{order.des}}</div>
                    <div class="mt-10 flex-row flex-j-sb">
                        <div class="fs-16">¥{{order.price}} <span class="fs-14 color-gray-dark ml-10">x{{order.num}}</span></div>

                    </div>
                </div>
            </div>
        </div>
        <div class="mt-10 bg-color-white">
            <van-cell title="货物状态" is-link @click="isReceive.show = true" :value='form.fields.isReceive.length < 1 ? "请选择" : isReceive.options[form.fields.isReceive]'></van-cell>
            <van-cell title="退款原因" is-link @click="returnCause.show = true" :value='form.fields.returnCause.length < 1 ? "请选择" : form.fields.returnCause'></van-cell>
        </div>
        <div class="mt-10 bg-color-white">
            <van-cell  class="total" title="退款金额" :value="`¥${order.payAmount}`"></van-cell>
        </div>
        <div class="mt-30">
            <van-button square  @click="onSubmit" type="danger" size="large" block>提交</van-button>
        </div>

        <van-popup v-model="isReceive.show" position="bottom" :style="{ height: '50%' }">
            <div class="flex-column flex-j-sb" style="height: 100%">
                <div>
                    <div class="fs-16 ta-c pt-20">货物状态</div>
                    <van-radio-group class="mt-30" v-model="form.fields.isReceive" >
                        <van-cell title="未收到货" clickable @click="form.fields.isReceive = 0 ">
                            <van-radio slot="right-icon" :name="0" />
                        </van-cell>
                        <van-cell title="已收到货" clickable @click="form.fields.isReceive = 1 ">
                            <van-radio slot="right-icon" :name="1" />
                        </van-cell>
                    </van-radio-group>
                </div>
                <div>
                    <van-button square  @click="isReceive.show = false" type="danger" size="large" block>关闭</van-button>
                </div>
            </div>
        </van-popup>

        <van-popup v-model="returnCause.show" position="bottom" :style="{ height: '50%' }">
            <div class="flex-column flex-j-sb" style="height: 100%">
                <div>
                    <div class="fs-16 ta-c pt-20">退款原因</div>
                    <van-radio-group v-model="form.fields.returnCause">
                        <van-cell  title="不喜欢/不想要" clickable @click="form.fields.returnCause = '不喜欢/不想要' ">
                            <van-radio slot="right-icon" name="不喜欢/不想要" />
                        </van-cell>
                        <van-cell title="货物破损已拒签" clickable @click="form.fields.returnCause = '货物破损已拒签' ">
                            <van-radio slot="right-icon" name="货物破损已拒签" />
                        </van-cell>
                    </van-radio-group>
                </div>
                <div>
                    <van-button square  @click="returnCause.show = false" type="danger" size="large" block>关闭</van-button>
                </div>
            </div>
        </van-popup>
    </div>

</template>

<script>
    import {Cell, NavBar, Stepper, Button, Toast, Popup, RadioGroup, Radio} from "vant";
    import * as GoodsApi from '@/api/goods';
    export default {
        name: "refund",
        data: () => ({
            order:{},
            isReceive:{
                show:false,
                value:'',
                options:{
                    0:"未收到货",
                    1:"已收到货"
                }
            },
            returnCause:{
                show:false,
                text:'',
                /*options:{
                    '0':{text:"不喜欢/不想要",value:"不喜欢/不想要"},
                    "1":{text:"货物破损已拒签",value:"货物破损已拒签"}
                }*/
            },
            form: {
                fields: {
                    orderId: "",
                    isReceive:"",
                    returnCause:""
                },
            }
        }),
        beforeRouteEnter(to, from, next) {
            GoodsApi.getOrder(to.params.id).then(data=>{
                next(vm => {
                    vm.setData(data);
                })
            })

        },
        beforeRouteUpdate (to, from, next) {
            GoodsApi.getOrder(to.params.id).then(data=>{
                this.setData(data);
                next();
            });
        },
        computed:{
            total:function () {
                return this.form.fields.num * this.goods.price;
            }
        },
        methods: {
            setData(data) {
                this.order = data;
                this.form.fields.orderId = data.id;
            },
            onSubmit() {
                if(this.form.fields.isReceive.length < 1) {
                    Toast("请选择货物状态");
                    return ;
                }
                if(this.form.fields.returnCause.length < 1) {
                    Toast("请选择退款原因");
                    return ;
                }
                GoodsApi.salesReturn(this.form.fields).then(data=>{
                    Toast({
                        type:'success',
                        message:"提交成功",
                        onClose: ()=> {
                            this.$router.replace({name:'shop-after-refund-view',params:{id:this.order.id}})
                        }
                    })
                }).catch(e=>{
                    Toast(e.msg);
                })
            }
        },
        components: {
            [Cell.name]: Cell,
            [NavBar.name]: NavBar,
            [Stepper.name]: Stepper,
            [Button.name]: Button,
            [Toast.name]: Toast,
            [Popup.name]: Popup,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
        },
    }
</script>

<style lang="less" scoped>
    .page-container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin: 0;
        box-sizing: border-box;
    }

    .address {
        .left-icon {
            width: 30px;
            height: auto;
        }

        .van-cell__value {

        }
    }

    .product {
        .left {
            width: 25vw;
            img {
                width: 100%;
                height: auto;
            }
        }
        .right {
            flex: 1;
        }
    }

    .total {
        font-size: 18px;
        .van-cell__value {
            color: #323233;
        }
    }
    .info {
        .title {
            position: relative;
            padding-left: 5px;
            &::before {
                position: absolute;
                top:6px;
                left: 0;
                width: 2px;
                background-color: @red;
                height: 14px;
                content: '';
            }
        }
    }

    .btn-submit {
        height: auto;
        line-height: normal;
    }
</style>